<template>
    <div class="row">
        <div v-for="(order) in orders" class="col-xs-12">
            <div>
                <div class="card">
                    <div class="card-header" v-on:click="show_order(order.id)">
                        <div class="col-xs-12">
                            <h4 class="card-title">Заказ на сумму {{order.sum + ''}}</h4>
                            <p class="category">{{order.dt}}</p>
                        </div>
                    </div>
                    <div class="card-content">
                        <div class="col-xs-12" v-on:click="show_order(order.id)" style="z-index: 99;">
                            <p class="text-success">{{order.status}}</p>
                            <p class="text" v-if="order.info.length>0">{{order.info}}</p>
                            <div v-if="opend_order.find((i)=>i===order.id)">
                                <center><i class="ti-angle-up"></i></center>
                            </div>
                            <div v-else>
                                <center><i class="ti-angle-down"></i></center>
                            </div>
                        </div>
                        <hr />
                        <div class="row">
                            <show-order v-if="opend_order.find((i)=>i===order.id)" v-bind:order_uuid="order.id"></show-order>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xs-12" style="margin-bottom: 80px;height: 40px">
            <hr/>
        </div>
        <div class="row" id="menu" style="position: fixed;z-index: 9990;background: rgba(4,7,6,0.27);height: 60px;bottom:0px;width: 100%;">
            <div class="col-xs-12" style=" padding-left: 4%; padding: 0px;border-top:1px ridge rgba(4,7,6,0.16);">
                <div class="col-xs-3" style="background: white;padding: 10px;">
                    <router-link to="/catalog">
                        <center>
                            <i class="ti-agenda" style="font-size: 20px;padding-top:6px;"></i>
                            <br/>
                            <span style="font-size: 1em;">Каталог</span>
                        </center>
                    </router-link>
                </div>
                <div class="col-xs-3" style="background: white;padding: 10px;">
                    <router-link to="/order">
                        <center>
                            <i class="ti-shopping-cart" style="font-size: 20px;padding-top:6px;"></i>
                            <br/>
                            <span style="font-size: 1em;">Заказ</span>
                        </center>
                    </router-link>
                </div>
                <div class="col-xs-3" style="padding: 10px;background: #ececec">
                    <router-link to="/orderslist">
                        <center>
                            <i class="ti-timer" style="font-size: 20px;padding-top:6px;"></i>
                            <br/>
                            <span style="font-size: 1em;">История</span>
                        </center>
                    </router-link>
                </div>
                <div class="col-xs-3" style="background: white;padding: 10px;">
                    <router-link to="/settings">
                        <center>
                            <i class="ti-more-alt" style="font-size: 20px;padding-top:6px;"></i>
                            <br/>
                            <span style="font-size: 1em;">Ещё</span>
                        </center>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import ShowOrder from './ShowOrder'
  export default {
    name: 'OrdersList',
    components: {ShowOrder},
    data () {
      return {
        orders: [],
        message: '',
        opend_order: []
      }
    },
    mounted () {
      this.get_orders()
    },
    methods: {
      get_orders () {
        // eslint-disable-next-line no-return-assign
        this.$db.orders.where('sum').above(0).reverse().sortBy('dt').then(x => this.orders = x)
      },
      date_format (dt) {
        var d = new Date(dt)
        return d.toLocaleString('ru-RU')
      },
      show_order (orderid) {
        var ind = this.opend_order.indexOf(orderid)
        if (ind >= 0) {
          this.opend_order.splice(ind, 1)
        } else {
          this.opend_order.push(orderid)
        }
      },
      save_order (orderid) {
      }
    }
  }
</script>

<style scoped>
    a {
        color: #000000;
    }
    .row{
        margin: 0px;
    }
</style>


// WEBPACK FOOTER //
// src/components/UIComponents/Custom/OrdersList.vue